import { payloadAction } from "../action/creators"

export const PROPAGATE_UNKNOWN_ERROR = "ERROR/PROPAGATE/UNKNOWN"
export const propagateUnknownError = payloadAction<unknown>(PROPAGATE_UNKNOWN_ERROR)

export const PROPAGATE_SIMPLE_MESSAGE_ERROR = "ERROR/PROPAGATE/SIMPLE_MESSAGE"
export const propagateSimpleMessageError = payloadAction<string>(PROPAGATE_SIMPLE_MESSAGE_ERROR)
